var _circle, _mask, _path, _rect, _rect2, _rect3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Paper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FFEFEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 38.9997H34.0001C35.1047 38.9997 36.0001 38.1042 36.0001 36.9997V20.7912V17.9995C36.0001 16.895 35.1047 15.9995 34.0001 15.9995H31.5001H20C18.8954 15.9995 18 16.895 18 17.9995V36.9997C18 38.1042 18.8954 38.9997 20 38.9997Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 37.9997H20V39.9997H34.0001V37.9997ZM19 36.9997V17.9995H17V36.9997H19ZM20 16.9995H31.5001V14.9995H20V16.9995ZM31.5001 16.9995H34.0001V14.9995H31.5001V16.9995ZM35.0001 17.9995V20.7912H37.0001V17.9995H35.0001ZM35.0001 20.7912V36.9997H37.0001V20.7912H35.0001ZM20 37.9997C19.4477 37.9997 19 37.552 19 36.9997H17C17 38.6565 18.3431 39.9997 20 39.9997V37.9997ZM34.0001 39.9997C35.657 39.9997 37.0001 38.6565 37.0001 36.9997H35.0001C35.0001 37.5519 34.5524 37.9997 34.0001 37.9997V39.9997ZM34.0001 16.9995C34.5524 16.9995 35.0001 17.4473 35.0001 17.9995H37.0001C37.0001 16.3427 35.657 14.9995 34.0001 14.9995V16.9995ZM19 17.9995C19 17.4473 19.4477 16.9995 20 16.9995V14.9995C18.3431 14.9995 17 16.3427 17 17.9995H19Z",
    fill: "#D91F05",
    mask: "url(#path-2-inside-1_1_36)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.263,
    y: 27.0001,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2631,
    y: 22.5,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.263,
    y: 31.5001,
    width: 9.94742,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.4739,
    cy: 16.5,
    rx: 1.89475,
    ry: 1.50001,
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Paper);
export default __webpack_public_path__ + "static/media/03paper.c5cdf516e7e4c63ac55d1a92a4a58018.svg";
export { ForwardRef as ReactComponent };